import React from "react";
import C from "helpers/HelpConstants";
import Item2Modal from "../Item2Modal";
import { HelpAbility } from "helpers/HelpAbility";

const Table2Modal = ({ vinculedClientes, desvinculedClient }) => {
    let myAbilities = HelpAbility();

    return (
        <div className="mt-4">
            <div className="row mb-2">
                <div className="col d-flex align-items-end">
                    <h6>Cliente Vinculado:</h6>
                </div>
            </div>
            <div className="table-responsive rounded-3" style={{ border: '1px solid black' }}>
                <table className="table">
                    <thead>
                        <tr>
                            <th scope="col">#</th>
                            <th scope="col" className="text-center">Nombre</th>
                            <th scope="col" className="text-center">Número de Documento</th>
                            {myAbilities.hasAny([C.A.DIRECTION.LINK]) &&
                                <th scope="col" className="text-center">Acción</th>
                            }
                        </tr>
                    </thead>
                    <tbody>
                        {
                            vinculedClientes.length
                                ? 
                                vinculedClientes.map((client, i) =>( 
                                    <Item2Modal key={client._id} client={client} i={i} desvinculedClient={desvinculedClient} />
                                )) 
                                :
                                <tr>
                                    <td colSpan="5">Sin datos</td>
                                </tr>
                        }
                    </tbody>
                </table>
            </div>
        </div>
    );
}
export default Table2Modal;
